(function () {
  'use strict';
  if (window.__hxReviews) return; window.__hxReviews = 1;

  function stats(s, cards) {
    var t = cards.length, sum = 0, c = [0, 0, 0, 0, 0, 0], ph = 0;
    cards.forEach(function (x) {
      var v = parseInt(x.getAttribute('data-stars'), 10) || 5;
      if (v < 1 || v > 5) v = 5;
      sum += v; c[v]++;
      if (x.hasAttribute('data-photo')) ph++;
    });
    var avg = t ? Math.round(sum / t * 10) / 10 : 0;
    s.querySelectorAll('[data-rf-total]').forEach(function (e) { e.textContent = t; });
    s.querySelectorAll('[data-rf-avg]').forEach(function (e) { e.textContent = avg; });
    s.querySelectorAll('[data-rf-row]').forEach(function (r) {
      var v = parseInt(r.getAttribute('data-rf-row'), 10);
      var i = r.querySelector('i'); if (i) i.style.width = (t ? Math.round(c[v] * 100 / t) : 0) + '%';
      var n = r.querySelector('[data-rf-c]'); if (n) n.textContent = c[v];
    });
    s.querySelectorAll('[data-rf-chip]').forEach(function (ch) {
      var k = ch.getAttribute('data-rf-chip');
      var n = k === 'photo' ? ph : (k === 'all' ? t : c[parseInt(k, 10)]);
      var sp = ch.querySelector('[data-n]'); if (sp) sp.textContent = n;
      ch.hidden = (k !== 'all' && n === 0);
    });
  }

  function initFeed(root) {
    root.querySelectorAll('[data-hx-rf]').forEach(function (s) {
      if (s.__hx) return; s.__hx = 1;
      var cards = Array.prototype.slice.call(s.querySelectorAll('.hx-rf__card'));
      if (s.hasAttribute('data-rf-auto')) stats(s, cards);
      var step = parseInt(s.getAttribute('data-initial'), 10) || 6;
      var shown = step, filter = 'all';
      var more = s.querySelector('.hx-rf__more');
      var empty = s.querySelector('.hx-rf__empty');
      function match(c) {
        if (filter === 'all') return true;
        if (filter === 'photo') return c.hasAttribute('data-photo');
        return c.getAttribute('data-stars') === filter;
      }
      function apply() {
        var list = cards.filter(match), n = 0;
        cards.forEach(function (c) { c.hidden = true; });
        list.forEach(function (c) { n++; c.hidden = n > shown; });
        if (more) more.hidden = list.length <= shown;
        if (empty) empty.hidden = list.length > 0;
      }
      if (more) more.addEventListener('click', function () { shown += step; apply(); });
      function toggle(btn, panel) {
        if (!btn || !panel) return;
        btn.addEventListener('click', function () {
          var open = panel.hidden;
          panel.hidden = !open;
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      }
      toggle(s.querySelector('.hx-rf__summary'), s.querySelector('.hx-rf__panel--sum'));
      toggle(s.querySelector('.hx-rf__filter-btn'), s.querySelector('.hx-rf__panel--filter'));
      var chips = s.querySelectorAll('[data-rf-filter]');
      chips.forEach(function (ch) {
        ch.addEventListener('click', function () {
          filter = ch.getAttribute('data-rf-filter');
          shown = step;
          s.querySelectorAll('.hx-rf__chip').forEach(function (x) { x.classList.toggle('is-active', x.getAttribute('data-rf-filter') === filter); });
          apply();
        });
      });
      var addBtn = s.querySelector('[data-rf-add]'), form = s.querySelector('.hx-rf__form');
      if (addBtn && form) addBtn.addEventListener('click', function (e) { e.preventDefault(); form.hidden = !form.hidden; if (!form.hidden) { var f = form.querySelector('input:not([type=hidden]),textarea'); if (f) f.focus(); } });
      if (form) {
        var rate = form.querySelectorAll('.hx-rf__rate button'), hidden = form.querySelector('[data-rf-stars]');
        rate.forEach(function (b) {
          b.addEventListener('click', function () {
            var v = parseInt(b.getAttribute('data-v'), 10);
            rate.forEach(function (x) { x.classList.toggle('is-on', parseInt(x.getAttribute('data-v'), 10) <= v); });
            if (hidden) hidden.value = v + ' כוכבים';
          });
        });
      }
      apply();
    });
  }

  function initWall(root) {
    root.querySelectorAll('[data-hx-pw]').forEach(function (s) {
      if (s.__hx) return; s.__hx = 1;
      var modal = s.querySelector('.hx-pw__modal');
      if (!modal) return;
      var body = modal.querySelector('.hx-pw__content');
      function close() { modal.hidden = true; document.documentElement.style.overflow = ''; }
      s.querySelectorAll('.hx-pw__tile').forEach(function (t) {
        t.addEventListener('click', function () {
          var tpl = t.querySelector('template');
          if (!tpl) return;
          body.innerHTML = '';
          body.appendChild(tpl.content.cloneNode(true));
          modal.hidden = false;
          document.documentElement.style.overflow = 'hidden';
        });
      });
      modal.addEventListener('click', function (e) { if (e.target === modal || e.target.closest('.hx-pw__close')) close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });
    });
  }

  function initMarq(root) {
    root.querySelectorAll('[data-hx-marq]').forEach(function (m) {
      if (m.__hx) return; m.__hx = 1;
      var track = m.querySelector('.hx-marq__track'), g = m.querySelector('.hx-marq__group');
      if (!track || !g || !g.children.length) return;
      var items = Array.prototype.slice.call(g.children);
      var guard = 0;
      while (g.scrollWidth < m.clientWidth + 40 && guard < 12) {
        items.forEach(function (it) { var c = it.cloneNode(true); c.removeAttribute('data-shopify-editor-block'); c.setAttribute('aria-hidden', 'true'); g.appendChild(c); });
        guard++;
      }
      var g2 = g.cloneNode(true); g2.setAttribute('aria-hidden', 'true');
      g2.querySelectorAll('[data-shopify-editor-block]').forEach(function (x) { x.removeAttribute('data-shopify-editor-block'); });
      track.appendChild(g2);
    });
  }

  function init(root) { root = root || document; initFeed(root); initWall(root); initMarq(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
